import { motion } from 'framer-motion';

interface CTASectionProps {
  onRegisterClick: () => void;
}

export default function CTASection({ onRegisterClick }: CTASectionProps) {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-[#101A2E] to-[#1E2430] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-[#D8B36A] rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D8B36A] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-5" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Зарегистрируйтесь сейчас
          </h2>
          
          <p className="text-base md:text-lg text-white/90 mb-8 max-w-2xl mx-auto">
            Не упустите возможность стать частью уникального профессионального сообщества в атмосфере петербургского вечера
          </p>

          <button
            onClick={onRegisterClick}
            className="px-8 py-4 bg-[#D8B36A] text-[#101A2E] rounded-xl font-bold text-base md:text-lg hover:bg-[#C9A459] transition-all duration-300 shadow-2xl hover:shadow-[#D8B36A]/50 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Забронировать место
          </button>

          <p className="text-sm text-white/70 mt-5">
            <i className="ri-time-line mr-1"></i>
            Занимает ~30 секунд. Мест немного.
          </p>
        </motion.div>
      </div>
    </section>
  );
}